//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import WasteDealDrawer from "./modules/WasteDealDrawer";
import { JeecgListMixin } from '@/mixins/JeecgListMixin';
import { GetSiteIdMixin } from '@/mixins/GetSiteIdMixin';
import { queryUserTreeList } from '@/api/api';
import { getAction } from '@/api/manage';
export default {
  name: 'WasteDealList',
  mixins: [JeecgListMixin, GetSiteIdMixin],
  components: {
    WasteDealDrawer: WasteDealDrawer
  },
  data: function data() {
    return {
      pagePath: '/om/waste/deal',
      pageTitle: '废液处置',
      userTree: [],
      companyList: [],
      // 表头
      isorter: {
        column: 'deal_date',
        order: 'desc'
      },
      siteColumn: {
        dataIndex: 'siteName',
        colName: 'site_id',
        title: '站点名称',
        align: 'center',
        sorter: true
      },
      columns: [{
        title: '序号',
        dataIndex: '',
        key: 'rowIndex',
        width: 60,
        align: 'center',
        customRender: function customRender(t, r, index) {
          return parseInt(index) + 1;
        }
      }, {
        dataIndex: 'dealDate',
        colName: 'deal_date',
        title: '处置时间',
        align: 'center',
        sorter: true
      }, {
        dataIndex: 'userId_userName',
        colName: 'user_id',
        title: '运维人员',
        align: 'center',
        sorter: true
      }, {
        dataIndex: 'companyName',
        colName: 'company_id',
        title: '处置公司',
        align: 'center',
        sorter: true
      }, {
        dataIndex: 'category_dictText',
        colName: 'category',
        title: '处置方式',
        align: 'center',
        sorter: true
      }, {
        dataIndex: 'quantity',
        colName: 'quantity',
        title: '废液总量（L）',
        align: 'center',
        sorter: true
      }, {
        dataIndex: 'fee',
        colName: 'fee',
        title: '处置费用（元）',
        align: 'center',
        sorter: true
      }, {
        title: '操作',
        dataIndex: 'action',
        align: 'center',
        width: 120,
        scopedSlots: {
          customRender: 'action'
        }
      }]
    };
  },
  created: function created() {
    this.queryParamList();
  },
  watch: {
    currentSiteId: function currentSiteId(value) {
      var ids = this.getTreeCurrentId();
      console.log(value);
      this.queryParam.scopeId = ids[1];
      this.queryParam.scope = ids[0];

      if (ids[0] == 1) {
        // 根据站点id
        this.queryParam.siteId = ids[1];
        this.spliceColumn(this.siteColumn);
      } else {
        // 根据区域id
        this.queryParam.siteId = undefined;
        this.spliceColumn(this.siteColumn, 1);
      }

      this.delayLoadData();
    }
  },
  computed: {},
  methods: {
    queryParamList: function queryParamList() {
      var _this = this;

      var that = this;
      that.userTree = [];
      that.companyList = []; // 用户

      queryUserTreeList().then(function (res) {
        if (res.success) {
          for (var i = 0; i < res.result.length; i++) {
            var temp = res.result[i];
            that.userTree.push(temp);
          }

          _this.loading = false;
        }
      });
      getAction('/ea/company/info/queryCompanyName').then(function (res) {
        if (res.success) {
          that.companyList = res.result;
        }
      });
    },
    onDateDealDate: function onDateDealDate(value, dateArray) {
      this.queryParam.dealDateStart = dateArray[0];
      this.queryParam.dealDateEnd = dateArray[1];
    },
    filterOption: function filterOption(input, option) {
      console.log('option', option.componentOptions.children[0].text);
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0;
    }
  }
};